var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"elevation":"8"}},[_c('v-card-title',[_vm._v(" Top 10 IP ultimo mese. ")]),_c('GChart',{attrs:{"type":"BarChart","data":_vm.values,"options":_vm.chartOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }